import React from 'react';
import Locations from '../../../../../components/Forms/locations/index';

function PMEVillages() {
  return <Locations module="pme" view="village" drawerTitle="Village" />
};

export default PMEVillages;
